export const DEV_PLAY_AS_SPECTATOR_STORAGE_KEY = 'dice1k-dev-play-as-spectator';
export const DEV_PLAY_AS_SPECTATOR_CHANGE_EVENT = 'dev-play-as-spectator-change';
const DEV_ZERO_BOT_DELAY_STORAGE_KEY = 'dice1k-dev-zero-bot-delay';
export const DEV_ZERO_BOT_DELAY_CHANGE_EVENT = 'dev-zero-bot-delay-change';

export function readDevPlayAsSpectatorPreference(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage?.getItem(DEV_PLAY_AS_SPECTATOR_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeDevPlayAsSpectatorPreference(enabled: boolean) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage?.setItem(DEV_PLAY_AS_SPECTATOR_STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    // ignore persistence errors
  }
  try {
    window.dispatchEvent(new Event(DEV_PLAY_AS_SPECTATOR_CHANGE_EVENT));
  } catch {
    // ignore event errors
  }
}

export function readDevZeroBotDelayPreference(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage?.getItem(DEV_ZERO_BOT_DELAY_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeDevZeroBotDelayPreference(enabled: boolean) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage?.setItem(DEV_ZERO_BOT_DELAY_STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    // ignore persistence errors
  }
  try {
    window.dispatchEvent(new Event(DEV_ZERO_BOT_DELAY_CHANGE_EVENT));
  } catch {
    // ignore event errors
  }
}
